import { Trans } from '@lingui/react/macro';

import Badge from '@/design_system/Badge';
import IconNoConnection from '@/icons/NoConnection.svg';
import useViewPort from '@/utils/useViewport';

export const NonDigitalizedBadge = () => {
  const { isMobile, isTablet } = useViewPort();

  return (
    <Badge size="small" color="secondary" borderRadius="soft" hasBorder>
      <IconNoConnection />
      {!isMobile && !isTablet && (
        <Trans id="components.workshop-list.non-digitalized">Non-digitalized</Trans>
      )}
    </Badge>
  );
};
